'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.curry');

var _lodash2 = _interopRequireDefault(_lodash);

var _of = require('./of');

var _of2 = _interopRequireDefault(_of);

var _constants = require('./helpers/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getWeek = function getWeek(_date) {
  var getWeekDay = function getWeekDay(d) {
    return d.getUTCDay() ? d.getUTCDay() : 7;
  };
  var date = new Date(_date);
  // 4th of jan is always week 1. This is because week numbers are ridiculous and make no logical sense
  var firstWeek = (0, _of2.default)([date.getUTCFullYear(), 0, 4]);
  // set the weekday to sunday
  date.setUTCDate(date.getUTCDate() + (7 - getWeekDay(date)));
  firstWeek.setUTCDate(firstWeek.getUTCDate() + (7 - getWeekDay(firstWeek)));
  var diff = date.getTime() - firstWeek.getTime();
  // return the diff in weeks. add 1 because we are starting at week 1
  // instead of negative week, return week 53 (of previous year)
  return diff < 0 ? 53 : 1 + Math.round(diff / _constants.DATE_UNITS.weeks);
}; //@flow


var getters = {
  'milliseconds': function milliseconds(date) {
    return date.getUTCMilliseconds();
  },
  'seconds': function seconds(date) {
    return date.getUTCSeconds();
  },
  'minutes': function minutes(date) {
    return date.getUTCMinutes();
  },
  'hours': function hours(date) {
    return date.getUTCHours();
  },
  'date': function date(_date2) {
    return _date2.getUTCDate();
  },
  'day': function day(date) {
    return date.getUTCDay();
  },
  'week': getWeek,
  'month': function month(date) {
    return date.getUTCMonth() + 1;
  },
  'year': function year(date) {
    return date.getUTCFullYear();
  }
};

exports.default = (0, _lodash2.default)(function (prop, date) {
  if (!getters.hasOwnProperty(prop)) return NaN;

  return getters[prop](date);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fp/build/get.js
// module id = 1372
// module chunks = 0 1 2 3 4 5 7 8 9